/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */

export const enum PaymentType {
  BANK_TRANSFER = '1',
  CASH = '2',
  CREDIT = '32',
  ACH = '4',
  VISA = '5',
  MASTERCARD = '6',
  AMERICAN_EXPRESS = '7',
  DISCOVER = '8',
  DINERS = '9',
  EUROCARD = '10',
  NOVA = '11',
  CREDIT_CARD_OTHER = '12',
  PAYPAL = '13',
  CHECK = '15',
  CARTE_BLANCHE = '16',
  UNIONPAY = '17',
  JCB = '18',
  LASER = '19',
  MAESTRO = '20',
  SOLO = '21',
  SWITCH = '22',
  ALIPAY = '27',
  SOFORT = '28',
  SEPA = '29',
  GOCARDLESS = '30',
  CRYPTO = '31',
  ZELLE = '33',
  MOLLIE_BANK_TRANSFER = '34',
  KBC = '35',
  BANCONTACT = '36',
  IDEAL = '37',
  HOSTED_PAGE = '38',
  GIROPAY = '39',
  PRZELEWY24 = '40',
  EPS = '41',
  DIRECT_DEBIT = '42',
  BECS = '43',
  ACSS = '44',
  INSTANT_BANK_PAY = '45',
  FPX = '46',
  KLARNA = '47',
  INTERAC = '48',
  BACS = '49',
  STRIPE_BANK_TRANSFER = '50',
  CASH_APP = '51',
  VENMO = '25',
  IZETTLE = '23',
  DEBIT = '3',
  GOOGLE_WALLET = '14',
  MONEY_ORDER = '26',
  SWISH = '24',
}
